var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangle11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 682,
    viewBox: "0 0 382 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000958049 12C0.000968274 5.37257 5.37355 0 12.001 0H370C376.628 0 382 5.3726 382 12L381.999 670C381.999 676.627 376.646 682 370.018 682C328.391 682 189.573 682 134.385 682C115.112 682 128.836 633 108 633H12C5.37259 633 8.28859e-06 627.627 1.85131e-05 621L0.000958049 12Z",
    fill: "#EEF6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle11);
export default __webpack_public_path__ + "static/media/Rectangle11.083c2f7c9778ba5244271e964fd8e533.svg";
export { ForwardRef as ReactComponent };